export default {
  serviceVersions: {},
  defaultServiceVersion: {}
}
